import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  contentWrapper: {
    alignItems: 'center',
  },
  formScreen: {
    flex: 1,
  },

  cardContainer: {
    width: '100%',
    maxWidth: 900,
    marginBottom: 16,
  },
  formFieldContainer: {
    width: '66%',
  },
  actionRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: 24,
  },

  infoText: {
    fontSize: 16,
    fontWeight: 400,
    color: colors.newUI.therapist.textBlue100,
    lineHeight: 20,
  },
  sectionDivider: {
    height: 1,
    backgroundColor: colors.newUI.therapist.bgBlue10,
    marginVertical: 16,
    width: '100%',
  },
});
